module.exports = __webpack_public_path__ + "img/b2ae3be.jpg";